import { createContext, useEffect, useState } from 'react'
import type { FC, ReactNode, Dispatch, SetStateAction } from 'react'
import type { TypeCustomer } from '@dy/commons/schema'
import { cookie, getPathnameType } from '@dy/commons/utils'
import { useQuery } from '@apollo/client'
import { GET_CUSTOMER } from '@/api'
import { useRouter } from 'next/router'

type TypeCustomerState = {
  customer: TypeCustomer,
  setCustomer: Dispatch<SetStateAction<TypeCustomer>>
  loaderActive: boolean,
  setLoaderActive: Dispatch<SetStateAction<boolean>>,
}

export const CustomerContext = createContext<TypeCustomerState | null>(null)

interface props {
  data?: TypeCustomer
  children: ReactNode
}

export const CustomerProvider: FC<props> = ({ data = null, children }) => {
  const [customer, setCustomer] = useState<TypeCustomer>(data)
  const [loaderActive, setLoaderActive] = useState<boolean>(false)
  const { asPath, pathname } = useRouter()

  const DYCustomerToken = cookie.get('DY_CUSTOMER_TOKEN')
  const { data:customerData } = useQuery<TypeCustomerState>(GET_CUSTOMER, {
    context: {
      isPrivatePath: true,
      DYCustomerToken
    },
    skip: !DYCustomerToken, // Skip the query if no customer token
  })
  const allowedPaymentMethods = ['giro','check','delivery','transferencia']

  useEffect(() => {
    const customer = customerData?.customer
    if (customer) {
      setCustomer(customer)
      cookie.set({ name: 'DY_CUSTOMER_PAYMENT_METHOD', value: customer.paymentMethod && allowedPaymentMethods.indexOf(customer.paymentMethod) !== -1 ? customer.paymentMethod : 'fallback' })
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerData])

  useEffect(() => {
    if (asPath.includes('logout=true')) return
    const pathnameType = getPathnameType(pathname)

    // Checking validity of token for the current store
    const checkValidToken = async () => {
      const token = process.env.DY_PRIVATE_STORE_ACCESS_TOKEN
      const resCheckToken = await fetch(`https://${process.env.DY_CMS}/graphql`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'DY-Access-Token': `${token}`,
          'DY-Customer-Token': DYCustomerToken
        },
        body: JSON.stringify({ query: `
            mutation CustomerTokenValidator {
              customerTokenValidator(input: {}) {
                ok
              }
            }
          `})
      })
      const data = resCheckToken.ok ? await resCheckToken.json() : null
      const valid = data?.data?.customerTokenValidator?.ok

      console.log('CustomerProvider - valid token:', valid, asPath)

      if (!valid && DYCustomerToken) {
        console.warn(`👮🏻‍♂️⛔️ ${asPath} Invalid TOKEN, trying to clear cookies`)
        if(pathnameType === 'private') window.location.href = '/?logout=true'
        // window.location.href =
        cookie.removeCookie('BC_CUSTOMER_ID')
        cookie.removeCookie('DY_CUSTOMER_TOKEN')
        setCustomer(null)

      }
    }
    checkValidToken()

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [asPath])

  return (
    <CustomerContext.Provider value={{ customer, setCustomer, loaderActive, setLoaderActive }}>
      {children}
    </CustomerContext.Provider>
  )
}
